export default __webpack_public_path__ + "static/media/snowmobile_dark.6365db39.png";